// src/components/molecules/InfoSection.js
import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, Typography } from "@mui/material";
import { useTheme } from "styled-components";

const InfoSection = ({ label, content, color }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 4 }}>
      <Grid container spacing={0} alignItems="center">
        <Grid item>
          <Box
            sx={{
              width: "10px",
              height: "75px",
              backgroundColor: color,
            }}
          />
        </Grid>
        <Grid item xs>
          <Box
            sx={{
              height: "75px",
              backgroundColor: theme.colors.headerPurple,
              padding: 2,
              display: "flex", // Use flexbox
              alignItems: "center", // Vertically center the content
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontFamily: "basic-sans", fontWeight: "700" }}
            >
              {label}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: theme.colors.mediumPurple,
              padding: 3,
            }}
          >
            {Array.isArray(content) ? (
              content.map((item, index) => (
                <Typography
                  key={index}
                  variant="body1"
                  mb={1}
                  sx={{ fontFamily: "basic-sans", lineHeight: "1.8em" }}
                >
                  {item}
                </Typography>
              ))
            ) : (
              <Typography
                variant="body1"
                sx={{ fontFamily: "basic-sans", lineHeight: "1.8em" }}
              >
                {content}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

InfoSection.propTypes = {
  label: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  color: PropTypes.string,
  bgColor: PropTypes.string,
};

export default InfoSection;
